import { get, post } from './request'
import { useDexStore } from '@/store'

const gateway = {
  dex: import.meta.env.VITE_APP_DEX_API,
}

/**
 * 查询用户钱包信息
 */
export const queryUserWalletInfo = () => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/wallet/${dexStore.chain}/getBalance`)
}

/**
 * 发送邮箱验证码
 */
type SendCodeData = {
  type: 0 | 1 | 2 | 3 | 4
  email: string
}
export const sendEmailCode = (data: SendCodeData) => {
  return post(`${gateway.dex}/api/v1/user/code`, data)
}

/**
 * 获取支持的链列表
 */
export const queryBlockChains = () => {
  return get(`${gateway.dex}/api/v1/common/blockchain`)
}

/**
 * 获取持仓列表
 */
export const queryHoldingList = () => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/${dexStore.chain}/position`)
}

/**
 * 获取挂单列表
 */
export const queryLimitOrderList = (data: any) => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/${dexStore.chain}/order-history`, data)
}

/**
 * 获取挂单列表
 */
export const queryOrderHistoryList = (data: any) => {
  const dexStore = useDexStore()
  return get(
    `${gateway.dex}/api/v1/${dexStore.chain}/swap/sbMtTxwjmRzZNWyPErdbIeXVGdScTX/trade-history-v1`,
    data,
  )
}

/**
 * 获取提币列表
 */
export const queryWithdrawalHistoryList = (data: any) => {
  const dexStore = useDexStore()
  return get(
    `${gateway.dex}/api/v1/wallet/withdraw/${dexStore.chain}/history`,
    data,
  )
}

/**
 * 获取池子详情
 */
export const queryPairsInfo = (address: string) => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/pool/${dexStore.chain}/pairs/${address}`)
}

/**
 * 获取代币详情
 */
export const queryTokenInfo = (address: string) => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/pool/${dexStore.chain}/token/${address}`)
}

/**
 * 获取订单详情
 */
export const queryOrderInfo = (id: string) => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/${dexStore.chain}/swap/${id}`)
}

/**
 * 获取交易设置
 */
export const queryTradeConfig = () => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/user/${dexStore.chain}/swap-config`)
}

/**
 * 保存交易设置
 */
export const saveTradeConfig = (data: any) => {
  const dexStore = useDexStore()
  return post(`${gateway.dex}/api/v1/user/${dexStore.chain}/swap-config`, data)
}

/**
 * 提交市价订单
 */
export const submitMarketOrder = (data: any) => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/${dexStore.chain}/swap`, data, {}, true)
}

/**
 * 提交限价订单
 */
export const submitLimitOrder = (data: any) => {
  const dexStore = useDexStore()
  return post(`${gateway.dex}/api/v1/${dexStore.chain}/limit-swap`, data, {}, true)
}

/**
 * 获取热门代币
 */
export const queryHotPairs = (
  data = {
    order: 'desc',
    sort: 'variation24h',
  },
) => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/pool/${dexStore.chain}/hot_pairs`, data)
}

/**
 * 收藏/取消 代币
 */
export const toggleFavorite = (address: string) => {
  const dexStore = useDexStore()
  return get(
    `${gateway.dex}/api/v1/token/${dexStore.chain}/${address}/favorite`,
  )
}

/**
 * 获取收藏代币
 */
export const queryFavorites = (
  data = {
    order: 'desc',
    sort: 'variation24h',
  },
) => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/pool/${dexStore.chain}/favorites`, data)
}

/**
 * 获取严选代币
 */
export const queryFeatured = (
  data = {
    order: 'desc',
    sort: 'variation24h',
  },
) => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/pool/${dexStore.chain}/featured`, data)
}

/**
 * 搜索代币
 */
export const searchPairs = (keyword: string) => {
  const options = Object.assign({ order: 'desc' }, { keyword })
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/pool/${dexStore.chain}/pairs`, options)
}

/**
 * 查询交易进度
 */
export const querySwapProgress = (id: string | number) => {
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/${dexStore.chain}/swap/${id}`)
}

/**
 * 取消限价单
 */
export const cancelOrder = (data: any) => {
  const dexStore = useDexStore()
  return post(
    `${gateway.dex}/api/v1/${dexStore.chain}/cancel-limit-order`,
    data,
    {},
    true
  )
}

/**
 * Bee换取token
 */
export const beeAuth = (data: any) => {
  return post(`${gateway.dex}/api/h5/v1/user/bee/auth`, data)
}

/**
 * 获取用户信息
 */
export const queryBeeUserInfo = () => {
  return post(`${gateway.dex}/api/h5/v1/user/bee/userInfo`)
}

/**
 * 用户提现
 */
export const submitWithdraw = (data: any, tokenAddress: string) => {
  const dexStore = useDexStore()
  return post(
    `${gateway.dex}/api/v1/wallet/withdraw/${dexStore.chain}/${tokenAddress}`,
    data,
    {},
    true
  )
}

/**
 * 用户提现详情
 */
export const getWithdrawDetail = (withdrawId: string) => {
  const options = Object.assign({ withdrawId })
  const dexStore = useDexStore()
  return get(`${gateway.dex}/api/v1/wallet/withdraw/${dexStore.chain}`, options)
}

/**
 * 获取用户信息
 */
export const queryUserInfo = () => {
  return get(`${gateway.dex}/api/v1/user/profile`)
}

/**
 * 获取用户信息
 */
export const heartCheck = () => {
  return get(`${gateway.dex}/api/v1/common/timestamp`)
}
